export default __webpack_public_path__ + "static/media/imageOne.bcc57ae1.png";